import React from 'react';
import { PNGS, SVGS } from '../../../assets';
import ZoButton from '@zonofi/zo-components/input/zo-button/zo-button';
import './waba-creation-success.scss';

interface WabaCreationSuccessProps {
  goToHome: () => void;
  userData: {
    phoneNumber: string;
    displayName: string;
    email: string;
  };
}

export const WabaCreationSuccess: React.FC<WabaCreationSuccessProps> = ({
  goToHome,
  userData,
}) => {
  return (
    <div className="waba-creation-success primary-font-regular">
      <div className="waba-creation-success-container">
        <img
          src={PNGS.SuccessTick}
          alt=""
          className="waba-creation-success-container-image"
        />
        <div className="waba-creation-success-container-text">
          <span className="waba-creation-success-container-text-heading primary-font-bold">
            WABA account created successfully!
          </span>
          <span className="waba-creation-success-container-text-description primary-font-regular">
            Now click on “Go to Home” button to navigate back to complete the
            flow.
          </span>
        </div>
        <div className="waba-creation-success-container-details">
          <div className="waba-creation-success-container-details-item">
            <span className="item-key">Phone Number</span>
            <span className="item-value primary-font-semibold">
              {`+${userData?.phoneNumber}`}
            </span>
          </div>
          <div className="waba-creation-success-container-details-item">
            <span className="item-key">Display Name</span>
            <span className="item-value primary-font-semibold">
              {userData?.displayName}
            </span>
          </div>
        </div>
      </div>
      <div className="waba-creation-success-footer">
        <ZoButton
          onClick={goToHome}
          label={'Go To Home'}
          startIcon={<img src={SVGS.HomeWhiteIcon} alt="" />}
          className="waba-creation-success-footer-button"
        />
      </div>
    </div>
  );
};
